export const ROLE_COMERCIAL = 'ROLE_COMERCIAL';
export const ROLE_SISTEMA = 'ROLE_SISTEMA';
export const ROLE_EXECUTIVO = 'ROLE_EXECUTIVO';
export const ROLE_INTERMEDIARIO = 'ROLE_INTERMEDIARIO';
export const ROLE_PLATAFORMA = 'ROLE_PLATAFORMA';
